import React, { useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import FileInput from "../../UiElement/FormElement/FileInput";
import useHttpHook from "../../../Hooks/HttpHook";
import Input from "../../UiElement/FormElement/Input";
import { EventLanguage } from "../../../utils/Languages";
import {
  EventDetailsApi,
  acceptTermsAndConditionsApi,
  ticketTermsAndCondition,
} from "../../../utils/ApiConstant";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import SubmitButtonGroup from "../../UiElement/FormElement/SubmitBtnGroup";
import { useSelector } from "react-redux";
import { EventById } from "../../../utils/ApiConstant";
import { updEventData } from "../../../ReduxSlice/Event/eventSlice";
import { useDispatch } from "react-redux";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";
const EventDetailsForm = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();
  let [loading, sendRequest, error] = useHttpHook();
  const FormLabal = EventLanguage.EventForm.DetailsForm.FormLabal;
  const { eventId } = useParams();
  const [TermsCondition, SetTermsCondition] = useState(false);
  const [videoUrlError, setVideoUrlError] = useState(false);
  const dispatch = useDispatch();
  const eventData = useSelector((state) => state.event);
  const [fileError, setFileError] = useState("");

  const hasStoredMainImage = (images) => {
    if (Array.isArray(images)) {
      return images.length > 0;
    }
    if (images && typeof images === "object") {
      return Boolean(images.path || images.filename);
    }
    return false;
  };

  const hasSelectedMainImage = (images) => {
    if (!Array.isArray(images) || images.length === 0) {
      return false;
    }
    return images.some((file) => file instanceof File || file instanceof Blob);
  };

  const [newEventData, setNewEventData] = useState({});

  const [customLoading, setCustomLoading] = useState(false);

  useEffect(() => {
    // if (eventData.status == false) {
    getEventData();
    // } else {
    // showingFormData(eventData);
    // }
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  useEffect(() => {
    setFileError("");
  }, [watch("mainimage")]);

  // useEffect(() => {
  //   if ((watch("mainimage") && watch("mainimage").length == 0) && (eventData.mainimage && eventData.mainimage.length == 0)) {
  //     setFileError("Please select a file");
  //   }
  // }, [watch("description")]);

  useEffect(() => {
    if (watch("videoLink") !== "") {
      if (
        !watch("videoLink")?.includes(process.env.REACT_APP_TV_VIDEO_BASE_URL)
      ) {
        setVideoUrlError(true);
      } else {
        setVideoUrlError(false);
      }
    }
  }, [watch("videoLink")]);

  const getEventData = async () => {
    const event = await sendRequest(EventById + eventId);
    if (event?.status === 1 && event?.data && !Array.isArray(event.data)) {
      dispatch(updEventData(event));
      showingFormData(event);
    }
  };
  const showingFormData = (eventResponse) => {
    const data = eventResponse?.data || {};
    reset({
      description: data.description || "",
      videoLink: data.video || "",
    });
  };
  let navigate = useNavigate();
  const onSubmit = async (data) => {
    // console.log(data, "--------- data -----------");
    try {
      if (
        !hasSelectedMainImage(data?.mainimage) &&
        !hasStoredMainImage(eventData?.data?.mainimage)
      ) {
        setFileError("Please select main image");
        return;
      }
      if (eventData?.data?.stepper?.step3) {
        let event = await sendRequest(EventDetailsApi + eventId, {
          method: "post",
          contentType: "multipart/form-data",
          data: data,
          imgFieldArr: ["mainimage", "gallery"],
        });
        if (event.status === 1) {
          dispatch(updEventData(event));
          props.isOnlyTicket !== true
            ? navigate(`/myEvents/${eventId}/tickets`, { replace: true })
            : toast("Event Details updated successfully");
        }
      } else {
        setNewEventData(data);

        let TermsAndConditionRes = await sendRequest(ticketTermsAndCondition);
        SetTermsCondition(TermsAndConditionRes?.data[0]?.description);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const VideoInputHandler = () => {
    if (!watch("videoLink").includes(process.env.REACT_APP_TV_VIDEO_BASE_URL)) {
      setVideoUrlError(true);
    } else {
      setVideoUrlError(false);
    }
  };

  const AcceptTermsAndCondition = async () => {
    if (
      !hasSelectedMainImage(newEventData?.mainimage) &&
      !hasStoredMainImage(eventData?.data?.mainimage)
    ) {
      setFileError("Please select main image");
      return;
    }
    // console.log(newEventData, "--------- data -----------");
    let event = await sendRequest(EventDetailsApi + eventId, {
      method: "post",
      contentType: "multipart/form-data",
      data: newEventData,
      imgFieldArr: ["mainimage", "gallery"],
    });
    if (event.status === 1) {
      dispatch(updEventData(event));
      let newEvent = await sendRequest(acceptTermsAndConditionsApi + eventId, {
        method: "post",
        contentType: "multipart/form-data",
        data: { acceptTermsAndCondition: true },
      });
      if (newEvent.status === 1)
        navigate(`/myEvents/${eventId}/tickets`, { replace: true });
    }
  };

  return (
    <MainComponentWrapper Loading={loading || customLoading} errorInfo={error}>
      <div className="evntFormUI">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="evntUserInfo bg-F9F9F9">
            <FileInput
              FieldName="mainimage"
              EventData={eventData}
              setFieldValue={setValue}
              labelTitle={FormLabal.eventImage.label}
              placeholder={FormLabal.eventImage.placeHolder}
              maxFiles={1}
              Register={register}
              multiple={false}
            />
            {fileError && <p className="text-danger">{fileError}</p>}
            <Input
              element="textarea"
              LabelCls="labelHeading"
              rows="4"
              placeholder={FormLabal.description.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="description"
              Label={FormLabal.description.label}
              ValidationArr={[{ Type: "required" }]}
            />
            <FileInput
              FieldName="gallery"
              multiple={true}
              EventData={eventData}
              setFieldValue={setValue}
              labelTitle={FormLabal.eventGalleryImage.label}
              placeholder={FormLabal.eventGalleryImage.placeHolder}
              Register={register}
            />

            <Input
              isIcon={true}
              element="text"
              LabelCls="labelHeading"
              rows="4"
              InputClassName="pr-5"
              placeholder={FormLabal.videoUpload.placeHolder}
              Register={register}
              Errors={errors}
              FieldName="videoLink"
              Label={FormLabal.videoUpload.label}
              // clickHandler={VideoInputHandler}
            />
            {videoUrlError && (
              <p>{EventLanguage.EventForm.DetailsForm.VideoError} </p>
            )}
            {props.isOnlyTicket == true ? (
              <SubmitButtonGroup isLoading={loading} SubmitBtnText="Submit" />
            ) : (
              <SubmitButtonGroup isLoading={loading} />
            )}
          </div>
        </form>
      </div>
      {TermsCondition && (
        <ModalWrapper
          title="Terms And Conditions"
          dialogClassName="event-terms-modal-dialog"
          contentClassName="event-terms-modal"
          headerClassName="event-terms-modal-header"
          bodyClassName="event-terms-modal-body"
          footerClassName="event-terms-modal-footer"
          closeClass="event-terms-modal-btn-close"
          submitClass="event-terms-modal-btn-ok"
          clickHandler={() => {
            AcceptTermsAndCondition();
          }}
          CloseModalHandler={() => {
            setCustomLoading(true);
            SetTermsCondition(false);
            // window.location.reload();
          }}
          isLoading={loading}
        >
          <div
            dangerouslySetInnerHTML={{ __html: TermsCondition }}
            className="event-terms-content"
          />
        </ModalWrapper>
      )}
    </MainComponentWrapper>
  );
};
export default EventDetailsForm;
